import './Essays.css';

// Add your essays here
const essays = [
  {
    title: "Example Essay Title",
    description: "A brief description of what this essay is about.",
    url: "https://example.com/essay-1",
    date: "Dec 2025"
  },
  // Add more essays like this:
  // {
  //   title: "Another Essay",
  //   description: "Description here.",
  //   url: "https://example.com/essay-2",
  //   date: "Nov 2025"
  // },
];

const Essays = () => {
  return (
    <div className="essays-page">
      <a href="/" className="back-link">← back</a>
      <main className="essays-main">
        <header className="essays-header">
          <h1 className="essays-title">Essays</h1>
        </header>

        <section className="essays-list">
          {essays.length > 0 ? (
            essays.map((essay, index) => (
              <a
                key={index}
                href={essay.url}
                target="_blank"
                rel="noopener noreferrer"
                className="essay-item"
              >
                <div className="essay-content">
                  <h2 className="essay-title">{essay.title}</h2>
                  {essay.description && (
                    <p className="essay-description">{essay.description}</p>
                  )}
                </div>
                <span className="essay-date">{essay.date}</span>
              </a>
            ))
          ) : (
            <p className="essays-empty">Essays coming soon...</p>
          )}
        </section>
      </main>
    </div>
  );
};

export default Essays;

